import type { UrlEntry, UrlRegion } from '@/types';

export const urls: Record<'blogAuthor', Record<UrlRegion, UrlEntry>> = {
  blogAuthor: {
    de: 'blog/autoren',
    'de-en': 'blog/authors',
    es: 'blog/autores',
    'es-en': 'blog/authors',
    fr: 'blog/auteurs',
    'fr-en': 'blog/authors',
    gb: 'blog/authors',
    nl: 'blog/auteurs',
    'nl-en': 'blog/authors',
    pt: 'blog/autores',
    'pt-en': 'blog/authors',
    us: 'blog/authors',
    ww: 'blog/authors',
  },
};
